import React, { useState, useEffect } from 'react';
import { IconButton } from '@chakra-ui/react';
import { FaArrowUp } from 'react-icons/fa';
import { useAudioPlayer } from '../context/AudioPlayerContext';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { currentEpisode } = useAudioPlayer();

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <IconButton
      aria-label="Scroll to top"
      icon={<FaArrowUp />}
      position="fixed"
      bottom={currentEpisode ? { base: '96px', md: '76px' } : '4'}
      right="4"
      colorScheme="brand"
      size="lg"
      onClick={scrollToTop}
      borderRadius="full"
      boxShadow="lg"
      opacity={isVisible ? 0.85 : 0}
      transform={isVisible ? 'translateY(0)' : 'translateY(12px)'}
      pointerEvents={isVisible ? 'auto' : 'none'}
      transition="opacity 0.3s, transform 0.3s"
      _hover={{ opacity: 1 }}
      zIndex={100}
    />
  );
};

export default ScrollToTop;
